

/**
 * Checks to see if an address is empty. We handle a few different scenarios.
 *
 * @param {Address} address
 *
 * @return {boolean}
 */
export default function isEmptyAddress(address) {
  if (!address || !Object.keys(address).length) {return true;}

  return Object.values(address).every((fieldValue) => !fieldValue);
}